module.exports = __webpack_public_path__ + "media/images/topbild-2000-1b4f2ecfc9d1d437f86d711f7df1ed86.jpg";